import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { AddContentButton } from '../../uiComponents/input/Buttons';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { Loading } from '../../uiComponents/Loading';
import { EditorStateModel } from '../../models/EditorStateModel';
import DraftHelper from '../../infrastructure/DraftHelper';
import { Redirect } from 'react-router-dom';
import { Vejledning } from '../../models/Vejledning';
import VejledningAfsnitEdit from '../Vejledning/VejledningAfsnitEdit';
import { Section } from '../../uiComponents/layout/Section';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { EditorState } from 'draft-js';

export interface OpgavepakkeVejledningContainerProps {
    vejledning?: Vejledning;
    editorStates: EditorStateModel[];
    validationResult: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
    onAfsnitRemoved: (index: number) => void;
    onAddAfsnit: () => void;
    onVejledningChanged: (index: number, fieldname: string, value: any) => void;
    onEditorChanged: (index: number, editorState: EditorState) =>  void;

}

interface OpgavepakkeVejledningContainerState {
}

export default class VejledningContainer extends React.Component<OpgavepakkeVejledningContainerProps, OpgavepakkeVejledningContainerState> {
    constructor(props: OpgavepakkeVejledningContainerProps) {
        super(props);   
    }
    
    getEditorState = (index: number): EditorStateModel | undefined => {
        return this.props.editorStates[index];
    }

    getAfsnit = () => {
        if (this.props.vejledning !== undefined) {
            if (this.props.vejledning.afsnit !== undefined) {
                const afsnitList = this.props.vejledning.afsnit.map((a, i) => {
                    let editorStateModel = this.getEditorState(i);
                    if (editorStateModel === undefined) {
                        editorStateModel = new EditorStateModel();
                        editorStateModel.index = i;
                        editorStateModel.editorState = DraftHelper.getEmptyEditorState();
                    }

                    return (
                        <VejledningAfsnitEdit
                            key={i}
                            afsnit={a}
                            errorMessages={[]}
                            editorState={editorStateModel.editorState}
                            index={i}
                            onEditorChanged={this.props.onEditorChanged}
                            onAfsnitChanged={this.props.onVejledningChanged}
                            onAfsnitRemoved={this.props.onAfsnitRemoved}
                        />
                    );
                });
                return afsnitList;
            }
        }
        return undefined;
    }

    render() {
        if (this.props.isSaved === false) {
            return (
                <Loading isLoading={this.props.vejledning === undefined}>
                    <SectionGroup header='Vejledning'>
                        <Section>
                            {this.getAfsnit()}
                            <Section>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <AddContentButton text={'Tilføj afsnit'} buttonOnClick={() => this.props.onAddAfsnit()} />
                                    </Col>
                                </Row>
                            </Section>
                        </Section>
                    </SectionGroup>
                </Loading>
            );
        } else {
            return <Redirect to='/' />;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeVejledningContainer.tsx